// extracted by mini-css-extract-plugin
module.exports = {"error":"error_error__2h8Jo","title":"error_title__14uaa","desc":"error_desc__3TKIv"};